// Meta Pixel integration
// Pixel ID: 1267046905612169

declare global {
  interface Window {
    fbq: any
    _fbq: any
  }
}

const PIXEL_ID = '1267046905612169'
let initialized = false

export function initPixel() {
  if (typeof window === 'undefined' || typeof document === 'undefined') return
  if (initialized && window.fbq) return
  if (window.fbq) {
    initialized = true
    return
  }

  try {
    // Build the queue function that fbevents.js will hydrate once loaded.
    const n: any = function () {
      n.callMethod ? n.callMethod.apply(n, arguments) : n.queue.push(arguments)
    }
    n.push = n
    n.loaded = true
    n.version = '2.0'
    n.queue = []
    window.fbq = n
    if (!window._fbq) window._fbq = n

    // Inject the fbevents.js script safely — fall back to <head> if there
    // are no existing <script> tags yet (which can happen in some
    // preview/sandbox environments).
    const t = document.createElement('script')
    t.async = true
    t.src = 'https://connect.facebook.net/en_US/fbevents.js'

    const existingScript = document.getElementsByTagName('script')[0]
    if (existingScript && existingScript.parentNode) {
      existingScript.parentNode.insertBefore(t, existingScript)
    } else if (document.head) {
      document.head.appendChild(t)
    } else {
      document.documentElement.appendChild(t)
    }

    window.fbq('init', PIXEL_ID)
    initialized = true
  } catch (err) {
    // eslint-disable-next-line no-console
    console.error('[Meta Pixel] init error', err)
  }
}

export function trackPageView() {
  if (typeof window === 'undefined') return
  if (!window.fbq) initPixel()
  if (window.fbq) window.fbq('track', 'PageView')
}

export function trackAddToCart(params?: {
  value?: number
  currency?: string
  content_name?: string
}) {
  if (typeof window === 'undefined') return
  if (!window.fbq) initPixel()
  if (!window.fbq) return

  window.fbq('track', 'AddToCart', {
    value: params?.value ?? 6390,
    currency: params?.currency ?? 'CLP',
    content_name: params?.content_name ?? 'Método Fuego Cero - eBook',
    content_ids: ['metodo-fuego-cero'],
    content_type: 'product',
  })

  // eslint-disable-next-line no-console
  console.log('[Meta Pixel] AddToCart fired', params)
}
